<template>
  <div class="speed-bg">
<!--    <van-nav-bar title="智能测速" />-->
    <h1 class="speed-title">{{ node.speed }}</h1>
    <span class="speed-sub-title">Mbps</span>

    <van-form style="position: absolute; margin-top: 80vh;">
      <van-cell-group inset>
        <van-field
          name="最优节点"
          label="最优节点"
          v-model="node.name"
          readonly=""
        />
      </van-cell-group>
    </van-form>
    <van-overlay :show="isLoading">
      <div class="mask" @click.stop>
        <van-loading vertical type="circular" size="50" color="#0094ff" v-if="isLoading"/>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { getAppNodes, updateAppNode } from '@/api/inapp'
const NetworkSpeed = require('network-speed')
const testNetworkSpeed = new NetworkSpeed()

export default {
  name: 'Speed',
  data () {
    return {
      isLoading: true,
      user_id: '',
      token: '',
      sign: '',
      nonce: '',
      nodes: [],
      node: {
        server_id: '',
        speed: 0
      }
    }
  },
  methods: {
    getNodes () {
      getAppNodes({}).then(res => {
        this.nodes = res.result.nodes
        this.nodes.forEach(item => {
          this.getNetworkDownloadSpeed(item)
        })
      })
    },
    getNetworkDownloadSpeed (item) {
      const baseUrl = 'https://' + item.domain + ':' + item.port + '/1m.iso?t=' + Math.round(new Date().getTime() / 1000)
      const fileSizeInBytes = 1024000
      testNetworkSpeed.checkDownloadSpeed(baseUrl, fileSizeInBytes).then(res => {
        console.log(res)
        item.speed = parseFloat(res.mbps)
        this.markNode(item)
        this.isLoading = false
      })
    },
    markNode (node) {
      if (this.node.server_id === '') {
        this.node = node
        this.submitNode()
      } else if (node.speed > this.node.speed) {
        this.node = node
        this.submitNode()
      }
    },
    submitNode () {
      updateAppNode({
        user_id: this.user_id,
        nonce: this.nonce,
        token: this.token,
        sign: this.sign,
        node: this.node
      }).then(res => {
        if (res.code !== 200) {
          this.$notify({type: 'primary', message: res.msg})
          return false
        }
        this.$notify({type: 'success', message: '测速完成'})
      })
    },
    initQuery () {
      console.log(this.$route.query)
      if (typeof this.$route.query.token !== 'undefined') {
        this.token = this.$route.query.token
      }
      if (typeof this.$route.query.sign !== 'undefined') {
        this.sign = this.$route.query.sign
      }
      if (typeof this.$route.query.user_id !== 'undefined') {
        this.user_id = this.$route.query.user_id
      }
      if (typeof this.$route.query.nonce !== 'undefined') {
        this.nonce = this.$route.query.nonce
      }
    },
    change () {
      this.getNodes()
    }
  },
  created () {
    this.$parent.isLoadUser = false
    this.$parent.showHeader = false
    this.$parent.showFooter = false
    this.$parent.showSkeleton = false
    document.title = 'Zerofast测速'
  },
  mounted () {
    this.initQuery()
    this.change()
  }
}
</script>

<style scoped>
.speed-bg {
  background: #000;
  background-image: url("https://www.zerofast.net/assets/images/70ab1e9e938f7d1bb748800198ad4740.jpeg");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
}

.speed-title {
  position: absolute;
  color: #fff;
  height: 50px;
  top: calc(50vh - 40px)
}
.speed-sub-title {
  font-size: 17px;
  position: absolute;
  color: rgba(255, 255, 255, 0.6);
  height: 30px;
  top: calc(50vh + 40px);
  font-weight: bolder;
}
.mask {
  position: absolute;
  width: 100vw;
  height: 100vh;
  margin-top: 40vh;
}
</style>



// WEBPACK FOOTER //
// src/components/inApp/Speed.vue